import React from 'react'
import _ from 'lodash'
import classNames from 'classnames'
import useAsync from 'modules/asyncCache/useAsync'
import useTranslate from 'modules/local/useTranslate'
import {appLog_getPageViewStats_Api} from 'apis'
import {RequiredSystemAdmin} from 'components/RequiredAdmin'
import {NullAsDefault} from 'views/Shared'

// Khớp Common::$pageViewKeys (backend) — xem AppController::getPageViewStats().
// align mặc định 'end' (canh phải, hợp góc đồng hồ/meta — vd MassTimesHeader); dùng 'start'
// khi đặt dưới title/description canh trái (pattern hero-gradient banner của các trang landing).
// 1 hàng ngang (số + nhãn + "admin only"), desktop thường đủ chỗ nằm 1 dòng; flex-wrap để tự
// xuống dòng khi chật (mobile / cạnh nội dung khác) — không ép breakpoint cứng.
const DefaultPageViewStatsContent = ({stats, align = 'end'}) => {
  const t = useTranslate()
  return (
    <div className={classNames(
      'flex flex-wrap items-baseline gap-x-1.5',
      align === 'start' ? 'justify-start' : 'justify-end'
    )}>
      <span className="font-bold text-sm text-color-000 leading-none tabular-nums">
        {stats.total_views}
      </span>
      <span className="text-2xs font-medium text-color-400 uppercase tracking-wide truncate">
        {t('page views')}
      </span>
      <span className="text-2xs italic text-color-300 leading-tight">
        ({t('admin only')})
      </span>
    </div>
  )
}

// Không đặt RequiredSystemAdmin ở đây — tách riêng để hook useAsync chỉ chạy khi
// PageViewStatsBadge (bên dưới) thực sự render children, tránh gọi API thừa cho user thường.
const PageViewStatsFetcher = ({type, render, align}) => {
  const {response} = useAsync({apiInfo: appLog_getPageViewStats_Api, values: {type}})
  const stats = _.get(response, 'data')
  if (!stats) return null

  return render ? render(stats) : <DefaultPageViewStatsContent stats={stats} align={align}/>
}

// Badge thống kê total_views/unique_visitors cho 1 page_key. Chỉ super admin thấy được —
// tự gate bên trong, call site không cần bọc thêm RequiredSystemAdmin.
// Truyền `render={(stats) => <.../>}` để tự custom giao diện khi UI khác biệt quá,
// mặc định dùng badge chuẩn (số lớn + label nhỏ), `align="start"|"end"` canh theo layout call site.
// `renderEmpty` (opt-in, mặc định không hiện gì - không đổi hành vi các chỗ đang dùng): dùng khi
// muốn hiện nội dung thay thế cho user thường (vd giữ nguyên stat cũ tại đúng vị trí đó).
export const PageViewStatsBadge = ({type, render, align, renderEmpty = NullAsDefault}) => (
  <RequiredSystemAdmin renderEmpty={renderEmpty}>
    <PageViewStatsFetcher type={type} render={render} align={align}/>
  </RequiredSystemAdmin>
)
export default PageViewStatsBadge
